import { IUpdateFuncionarioAssinaturaUseCase } from "../../../presentation/useCases/update/update_funcionario_assinatura_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateFuncionarioAssinaturaUseCase
 */

export class UpdateFuncionarioAssinaturaUseCase implements IUpdateFuncionarioAssinaturaUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
    idFuncionario: number,
    nroRegistro: string | null,
    ativo: number,
    file: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.repository.updateFuncionarioAssinatura(
      idFuncionarioAssinatura,
      ativo,
      idFuncionario,
      file,
      nroRegistro,
      limparArquivo,
    );
  }
}